import { Directive, ElementRef, Input, OnInit } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { PropertyMetadata } from "@tylertech/tyler-api-types";

@Directive({
    selector: "[focusOnLoad]",
    standalone: false
})
export class FocusOnLoadDirective implements OnInit
{
    @Input() readonly forCellEdit: boolean;
    @Input() readonly propertyMetadata: PropertyMetadata;

    constructor(private hostElement: ElementRef) { }

    ngOnInit()
    {
        const self = this;
        let shouldFocus = this.forCellEdit;
        if (!shouldFocus)
            return;

        requestAnimationFrame(()=>
        {
            if (this.nonSelectableInput(this.propertyMetadata?.InputType))
                self.hostElement.nativeElement.focus();
            else
                self.hostElement.nativeElement.select();
        });
    }

    private nonSelectableInput(inputType: string): boolean
    {
        return inputType === "Check" || inputType === "Button"
            || inputType === "Color" || inputType === "Select"
            || Utilities.IsNullOrUndefinedOrEmpty(inputType);
    }
}
